import basePath from "base_path";
import ActionTypes from "../constants/action_types";
import requestor from "requestor";
import createReduxPromiseAction from "utils/create_redux_promise_action";

export default createReduxPromiseAction(
  ActionTypes.ISSUE_RESPONSE_COPY_CLICK,
  (organisationId, projectId, documentId, issueId, issueResponseId) =>
    requestor
      .post(
        `${basePath}/organisation/${organisationId}/project/${projectId}/document/${documentId}/issue/${issueId}/issue_response/${issueResponseId}/log`,
        {},
        {
          withCredentials: true,
        },
      )
      .then(response => response.data),
);
